import { jsx as _jsx } from "react/jsx-runtime";
import { FormHelperText } from '@mui/material';
import { colCenter } from '@ui/style/style';
const FormValidationMessage = ({ error }) => {
    return (_jsx(FormHelperText, { error: true, sx: { ...colCenter, mt: 0, gap: 0.5, ml: 0 }, children: error }));
};
export default FormValidationMessage;
